import React from "react";
import {
    Button,
    DownloadIcon,
    Flex,
    MenuButton,
    MoreIcon,
    TrashCanIcon,
} from "@fluentui/react-northstar";
import styled from "styled-components";
import { useMutation } from "react-query";
import { downloadFile } from "../../../view_document/api";
import { useToastGlobal } from "../../../../stores/useToastGlobal";
import DialogConfirmationDelete from "../DialogDeleteConfirmation/DialogConfirmationDelete";
import { _api_delete_document } from "../../api";
import { queryClient } from "../../../..";
import {
    QUERY_KEY_DOCUMENTS_HR_GET_FILES,
    QUERY_KEY_DOCUMENTS_HR_SEARCH_DOCUMENTS,
} from "../../hooks/useLogicDocumentsHr";

const CellMore = ({ document_id }) => {
    const [open, setOpen] = React.useState(false);
    const alert = useToastGlobal();

    const { isLoading: isDownloadingDocument, mutate: mutateDownloadDocument } =
        useMutation((data) => downloadFile(data), {
            onSuccess: (data) => {
                setOpen(false);
                if (data?.success) {
                    alert.setShow({
                        ...alert,
                        visible: true,
                        level: "success",
                        content: "Téléchargement réussi",
                    });
                } else {
                    alert.setShow({
                        ...alert,
                        visible: true,
                        level: "danger",
                        content: data?.message
                            ? data?.message
                            : "le téléchargement a échoué",
                    });
                }
            },
        });
    const { isLoading: isDeletingDocument, mutate: mutateDeleteDocument } =
        useMutation((data) => _api_delete_document(data), {
            onSuccess: (data) => {
                setOpen(false);
                if (data?.success) {
                    queryClient.invalidateQueries(
                        QUERY_KEY_DOCUMENTS_HR_GET_FILES
                    );
                    queryClient.invalidateQueries(
                        QUERY_KEY_DOCUMENTS_HR_SEARCH_DOCUMENTS
                    );
                    queryClient.invalidateQueries({
                        predicate: (query) =>
                            query.queryKey.some(
                                (key) =>
                                    typeof key === "string" &&
                                    key.includes("::search_documents")
                            ),
                    });
                    alert.setShow({
                        ...alert,
                        visible: true,
                        level: "success",
                        content: "Suppression effectuée",
                    });
                } else {
                    alert.setShow({
                        ...alert,
                        visible: true,
                        level: "danger",
                        content: "Le suppression a échoué",
                    });
                }
            },
        });

    return (
        <MenuButton
            open={open}
            onOpenChange={(e, { open }) => {
                e.preventDefault();
                e.stopPropagation();
                setOpen(open);
            }}
            trigger={
                <div>
                    <MoreIconStyle />
                </div>
            }
            menu={[
                <Button
                    size="small"
                    key="download"
                    icon={<DownloadIcon size="small" />}
                    content="Télécharger"
                    loading={isDownloadingDocument}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        mutateDownloadDocument({ document_id });
                    }}
                    text
                />,
                <DialogConfirmationDelete
                    handleConfirmDeleteDocument={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        mutateDeleteDocument(document_id);
                    }}
                    isDeleting={isDeletingDocument}
                    trigger={
                        <ButtonDanger
                            size="small"
                            key="delete"
                            icon={<TrashCanIcon size="small" />}
                            content="Supprimer"
                            text
                        />
                    }
                />,
            ]}
            on="click"
        />
    );
};

export default CellMore;

const MoreIconStyle = styled(MoreIcon)`
    cursor: pointer;
`;

const ButtonDanger = styled(Button)`
    color: var(--color-danger);
`;
